import 'froala-editor/css/froala_style.css';
import '../css/vendor/_froala_iframe.scss';
import 'iframe-resizer/js/iframeResizer.contentWindow';
